// import {colors} from "./colors";
// import {unstable_createMuiStrictModeTheme as createTheme} from "@mui/material";
// import {enUS} from "@mui/material/locale";
//
// export const theme = createTheme({
//
//
//     typography: {
//         allVariants: {
//             color: colors.font.dark
//         }
//     },
//     palette: {
//         background: {
//             default: colors.bg.main
//         },
//         primary: {
//             light: colors.primary.light,
//             main: colors.primary.main,
//             dark: colors.primary.dark,
//             contrastText: colors.primary.contrastText
//         },
//         secondary: {
//             light: colors.secondary.light,
//             main: colors.secondary.main,
//             dark: colors.secondary.dark
//         },
//         tertiary: {
//             light: colors.tertiary.light,
//             main: colors.tertiary.main,
//             dark: colors.tertiary.dark
//         },
//         success: {
//             main: colors.success.main
//         },
//         error: {
//             main: colors.error.main
//         },
//         bg: {
//             main: colors.bg.main
//         },
//         font: {
//             md: colors.font.md,
//             dark: colors.font.dark,
//             light: colors.font.light
//         },
//         grey: {
//             dark: colors.grey.dark
//         }
//     },
//     overrides: {
//         MuiButton: {
//             root: {
//                 border: "solid 1px transparent",
//                 borderRadius: 4,
//                 '&:active': {
//                     border: `solid 1px ${colors.primary.dark}`
//                 }
//             },
//             contained: {
//                 borderRadius: 20,
//                 "&$disabled": {
//                     backgroundColor: "#ffeaa3",
//                     color: "#fff",
//                 },
//                 '&:active': {
//                     border: "solid 1px transparent !important"
//                 }
//             },
//             outlined: {
//                 borderRadius: 20,
//                 border: `solid 1px ${colors.primary.dark} !important`,
//                 '&$disabled': {
//                     border: "solid 1px #efeff5 !important",
//                 },
//                 '&:active': {
//                     border: "none"
//                 }
//             }
//         },
//         MuiCheckbox: {
//             colorPrimary: {
//                 '&$disabled': {
//                     '&$checked': {
//                         color: "#FFE280"
//                     }
//                 }
//             }
//         },
//         MuiInputLabel: {
//             root: {
//                 color: "#ccc",
//                 paddingLeft: "0.5em"
//             }
//         },
//         MuiTab: {
//             root: {
//                 textTransform: "none"
//             }
//         },
//         MuiTabs: {
//             root: {
//                 backgroundColor: colors.bg.main,
//                 color: colors.font.dark,
//             }
//         },
//         MuiTypography: {
//             subtitle1: {
//                 fontWeight: 500,
//             },
//             h5: {
//                 fontWeight: 500,
//             },
//             body1: {
//                 lineHeight: 1.75,
//                 letterSpacing: "0.0275em"
//             },
//             body2: {
//                 lineHeight: 1.43,
//                 letterSpacing: "0.01562em"
//             },
//             caption: {
//                 lineHeight: 1.33,
//                 letterSpacing: "0.025em",
//                 color: colors.font.light
//             },
//             overline: {
//                 letterSpacing: "0.09375em",
//                 fontSize: "0.625rem",
//                 lineHeight: 1.6
//             }
//         },
//         MuiInput: {
//             underline: {
//                 '&:after': {
//                     borderBottom: `2px solid ${colors.secondary.main}`
//                 },
//                 "&$error:after": {
//                     borderBottom: `2px solid ${colors.error.main}`
//                 }
//             },
//         },
//         MuiFormLabel: {
//             root: {
//                 '&$focused:not($error)': {
//                     color: `${colors.secondary.main} !important`,
//                 },
//                 /*"&$error:after": {
//                     color: "#f44336"
//                 }*/
//             }
//         },
//         MuiFormHelperText: {
//             root: {
//                 '&$focused:not($error)': {
//                     color: `${colors.secondary.main} !important`
//                 }
//             }
//         },
//         MuiTableCell: {
//             root: {
//                 padding: '16px 0 16px 32px'
//             },
//             head: {
//                 backgroundColor: "#efeff5 !important"
//             }
//         },
//         MuiTableRow: {
//             root: {
//                 height: "64px"
//             }
//         },
//         MuiTooltip: {
//             tooltip: {
//                 backgroundColor: colors.grey.dark,
//                 color: "#fff",
//                 lineHeight: 1.43,
//                 padding: "20px !important",
//                 fontSize: "0.875rem",
//                 letterSpacing: "0.01562em"
//             },
//             arrow: {
//                 color: colors.grey.dark
//             }
//         },
//         MuiStepLabel: {
//             root: {
//                 marginBottom: 10,
//             },
//             active: {
//                 backgroundColor: 'rgba(79, 192, 232, 0.3) !important',
//                 color: '#42a1c3 !important',
//             },
//             completed: {
//                 backgroundColor: 'transparent !important',
//                 color: '#757575 !important'
//             },
//         },
//         MuiChip: {
//             label: {
//                 fontSize: "0.875rem",
//                 fontWeight: 500,
//             }
//         },
//         MuiAutocomplete: {
//             root: {
//                 border: "none"
//             }
//         },
//         MuiSelect: {
//             root: {
//                 paddingLeft: 8
//             }
//         },
//         MuiPopover: {
//             root: {
//                 marginTop: "0.75em"
//             }
//         },
//         MuiCardContent: {
//             root: {
//                 '&:last-child': {
//                     paddingBottom: "1em"
//                 }
//             }
//         },
//         MuiPickersToolbar: {
//             toolbar: {
//                 backgroundColor: "#fff",
//             },
//         },
//         MuiPickersToolbarText: {
//             toolbarTxt: {
//                 color: "#757575"
//             },
//             toolbarBtnSelected: {
//                 color: "#000"
//             }
//         },
//         MuiPickersBasePicker: {
//             pickerView: {
//                 borderTop: "1px solid #efeff5"
//             }
//         }
//     },
//
//     props: {
//         MuiButton: {
//             disableElevation: true
//         }
//     },
//     spacing: [4, 8, 16, 24, 32, 40, 48, 56, 64, 72, 80],
//
// }, enUS)

import { colors } from "./colors";
import { createTheme } from "@mui/material/styles";
import { enUS } from "@mui/material/locale";

export const theme = createTheme({
    typography: {
        allVariants: {
            color: colors.font.dark,
        },
    },
    palette: {
        background: {
            default: colors.bg.main,
        },
        primary: {
            light: colors.primary.light,
            main: colors.primary.main,
            dark: colors.primary.dark,
            contrastText: colors.primary.contrastText,
        },
        secondary: {
            light: colors.secondary.light,
            main: colors.secondary.main,
            dark: colors.secondary.dark,
        },
        tertiary: {
            light: colors.tertiary.light,
            main: colors.tertiary.main,
            dark: colors.tertiary.dark,
        },
        success: {
            main: colors.success.main,
        },
        error: {
            main: colors.error.main,
        },
        bg: {
            main: colors.bg.main,
        },
        font: {
            md: colors.font.md,
            dark: colors.font.dark,
            light: colors.font.light,
        },
        grey: {
            dark: colors.grey.dark,
        },
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    border: "solid 1px transparent",
                    borderRadius: 4,
                    '&:active': {
                        border: `solid 1px ${colors.primary.dark}`,
                    },
                },
                contained: {
                    borderRadius: 20,
                    '&$disabled': {
                        backgroundColor: "#ffeaa3",
                        color: "#fff",
                    },
                    '&:active': {
                        border: "solid 1px transparent !important",
                    },
                },
                outlined: {
                    borderRadius: 20,
                    border: `solid 1px ${colors.primary.dark} !important`,
                    '&$disabled': {
                        border: "solid 1px #efeff5 !important",
                    },
                    '&:active': {
                        border: "none",
                    },
                },
            },
        },
        MuiCheckbox: {
            styleOverrides: {
                colorPrimary: {
                    '&$disabled': {
                        '&$checked': {
                            color: "#FFE280",
                        },
                    },
                },
            },
        },
        MuiInputLabel: {
            styleOverrides: {
                root: {
                    color: "#ccc",
                    paddingLeft: "0.5em",
                },
            },
        },
        MuiTab: {
            styleOverrides: {
                root: {
                    textTransform: "none",
                },
            },
        },
        MuiTabs: {
            styleOverrides: {
                root: {
                    backgroundColor: colors.bg.main,
                    color: colors.font.dark,
                },
            },
        },
        MuiTypography: {
            styleOverrides: {
                subtitle1: {
                    fontWeight: 500,
                },
                h5: {
                    fontWeight: 500,
                },
                body1: {
                    lineHeight: 1.75,
                    letterSpacing: "0.0275em",
                },
                body2: {
                    lineHeight: 1.43,
                    letterSpacing: "0.01562em",
                },
                caption: {
                    lineHeight: 1.33,
                    letterSpacing: "0.025em",
                    color: colors.font.light,
                },
                overline: {
                    letterSpacing: "0.09375em",
                    fontSize: "0.625rem",
                    lineHeight: 1.6,
                },
            },
        },
        MuiInput: {
            styleOverrides: {
                underline: {
                    '&:after': {
                        borderBottom: `2px solid ${colors.secondary.main}`,
                    },
                    '&$error:after': {
                        borderBottom: `2px solid ${colors.error.main}`,
                    },
                },
            },
        },
        MuiFormLabel: {
            styleOverrides: {
                root: {
                    '&$focused:not($error)': {
                        color: `${colors.secondary.main} !important`,
                    },
                },
            },
        },
        MuiFormHelperText: {
            styleOverrides: {
                root: {
                    '&$focused:not($error)': {
                        color: `${colors.secondary.main} !important`,
                    },
                },
            },
        },
        MuiTableCell: {
            styleOverrides: {
                root: {
                    padding: '16px 0 16px 32px',
                },
                head: {
                    backgroundColor: "#efeff5 !important",
                },
            },
        },
        MuiTableRow: {
            styleOverrides: {
                root: {
                    height: "64px",
                },
            },
        },
        MuiTooltip: {
            styleOverrides: {
                tooltip: {
                    backgroundColor: colors.grey.dark,
                    color: "#fff",
                    lineHeight: 1.43,
                    padding: "20px !important",
                    fontSize: "0.875rem",
                    letterSpacing: "0.01562em",
                },
                arrow: {
                    color: colors.grey.dark,
                },
            },
        },
        MuiStepLabel: {
            styleOverrides: {
                root: {
                    marginBottom: 10,
                },
                active: {
                    backgroundColor: 'rgba(79, 192, 232, 0.3) !important',
                    color: '#42a1c3 !important',
                },
                completed: {
                    backgroundColor: 'transparent !important',
                    color: '#757575 !important',
                },
            },
        },
        MuiChip: {
            styleOverrides: {
                label: {
                    fontSize: "0.875rem",
                    fontWeight: 500,
                },
            },
        },
        MuiAutocomplete: {
            styleOverrides: {
                root: {
                    border: "none",
                },
            },
        },
        MuiSelect: {
            styleOverrides: {
                root: {
                    paddingLeft: 8,
                },
            },
        },
        MuiPopover: {
            styleOverrides: {
                root: {
                    marginTop: "0.75em",
                },
            },
        },
        MuiCardContent: {
            styleOverrides: {
                root: {
                    '&:last-child': {
                        paddingBottom: "1em",
                    },
                },
            },
        },
    },
    spacing: [4, 8, 16, 24, 32, 40, 48, 56, 64, 72, 80],
}, enUS);
